export const tr = (obj) => {
    const params = new URLSearchParams(window.location.search)
    const lang = params.get("lang")
    return obj[lang] ?? obj["en"]
}